import React, { useState, useImperativeHandle, forwardRef, useRef } from 'react';
import { PaymentForm, CreditCard } from "react-square-web-payments-sdk";
import { Input } from './common';

const SquarePaymentForm = forwardRef(({ onChange, onTokenReceived, onError }, ref) => {
  const [cardholderName, setCardholderName] = useState('');
  const creditCardRef = useRef(null);

  const handleNameChange = (e) => {
    const newName = e.target.value;
    setCardholderName(newName);

    if (onChange) {
      onChange({ type: 'name', value: newName });
    }
  };

  const handleCardTokenize = async (token, buyer) => {
    try {
      if (onTokenReceived) {
        await onTokenReceived(token, buyer);
      }
    } catch (error) {
      if (onError) {
        onError(error.message || 'Payment processing failed');
      }
    }
  };

  useImperativeHandle(ref, () => ({
    submit: () => {
      const submitButton = document.getElementById('rswp-card-button');
      if (submitButton) {
        submitButton.click();
      }
    }
  }));

  return (
    <PaymentForm
      applicationId={process.env.REACT_APP_SQUARE_APPLICATION_ID}
      locationId={process.env.REACT_APP_SQUARE_LOCATION_ID}
      cardTokenizeResponseReceived={handleCardTokenize}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <div>
          <label style={{ fontSize: 14, marginBottom: 4, display: 'block' }}>Cardholder Name</label>
          <Input
            value={cardholderName}
            onChange={handleNameChange}
            placeholder="Name on card"
            autoComplete="cc-name"
          />
        </div>
        <div>
          <label style={{ fontSize: 14, marginBottom: 4, display: 'block' }}>Card Information</label>
          <CreditCard
            ref={creditCardRef}
            buttonProps={{
              css: { display: 'none' },
            }}
            callbacks={{
              focusClassAdded: () => onError(null),
              focusClassRemoved: () => onError(null),
              cardNonceResponseReceived: (errors) => {
                if (errors) {
                  if (onError) {
                    onError(errors[0]?.message || 'Card validation failed');
                  }
                } else {
                  // Clear any previous errors
                  if (onError) {
                    onError(null);
                  }
                }
              },
            }}
          />
        </div>
      </div>
    </PaymentForm>
  );
});

export default SquarePaymentForm;
